module.exports = __webpack_public_path__ + "static/media/allergy_slider_phone1.429a50a8.png";